@if (views().length > 0) {
  <span class="ds-overline page-filter-chips-caption">{{ '#CORE_FILTER.CHIPS.TITLE' | translate }}</span>
  <ul class="page-filter-chips-list" data-testid="filter-chips">
    @for (view of views(); track view.chip.id) {
      <li>
        <soft-ds-chip variant="primary-tinted"
                      size="sm"
                      maxWidth="var(--ds-spacing-27)"
                      removable
                      [removeLabel]="view.removeLabel"
                      (remove)="remove(view.chip)"
                      data-testid="filter-chip">
          <ng-template softSlot="leading">
            <soft-ds-icon [name]="view.chip.item.config.icon" size="xs" aria-hidden="true" />
          </ng-template>
          <button type="button"
                  class="page-filter-chip-body"
                  [attr.aria-label]="view.editLabel"
                  [attr.title]="view.fullText"
                  (click)="openItem(view.chip)"
                  data-testid="filter-chip-body">
            <span>{{ view.title }}@if (view.chip.kind !== 'toggle' && !view.showsOperator) {: {{ view.value }} }</span>
            @if (view.chip.kind !== 'toggle' && view.showsOperator) {
              <soft-filter-operator class="page-filter-chip-operator" [operator]="view.chip.filter.operator" />
              @if (view.value; as value) {
                <span>{{ value }}</span>
              }
            }
          </button>
        </soft-ds-chip>
      </li>
    }
  </ul>
}
